import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import { BodySmall } from 'styles/typography';

// The orange "read this" banner for the inbound-referral surfaces — the duplicate-insurance warning
// on the referral entry form, and the sync-patient modal's three. Shared rather than restyled per
// screen so the same weight of message can't end up looking like two different things.
//
// A column with a gap because callers put more than a sentence in it.
export const WarningBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid ${colors.orange50};
  background: ${colors.orange10};
`;

// Body copy inside the banner. Full-strength text rather than the muted grey used for hints: the
// banner exists to be noticed, and grey-on-orange undoes that.
export const WarningBannerText = styled(BodySmall)`
  display: block;
  color: ${colors.black100};
`;
